import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { custom } from "../../../redux/actions/utilities";
import { systemConstants } from "../../../constants";

export const MobileDetectionWrapper = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const checkMobile = () => {
      dispatch(
        custom(window.innerWidth <= 768, systemConstants.MOBILE_DETECTION)
      );
    };

    checkMobile();
    window.addEventListener(systemConstants.RESIZE, checkMobile);

    return () => window.removeEventListener(systemConstants.RESIZE, checkMobile);
  }, [dispatch]);

  return <>{children}</>;
};
